import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormattedMessage } from 'i18n';
import {
  LUGGAGE as LUGGAGE_SERVICE,
  CABIN_LUGGAGE as CABIN_LUGGAGE_SERVICE,
} from 'routes/checkoutPage/constants/servicesKeys';
import servicesIconsMap from 'routes/checkoutPage/constants/servicesIconsMap';
import firstCharToLowerCase from 'utils/string/firstCharToLowerCase';
import { INFANT } from 'state/checkoutPage/travelers/constants/passengerTypes';

export default function LuggageInfo({ segments, firstLeg }) {
  const [services, setServices] = useState([
    {
      type: CABIN_LUGGAGE_SERVICE,
      included: false,
    },
    {
      type: LUGGAGE_SERVICE,
      included: false,
    },
  ]);

  useEffect(() => {
    const includedServices = firstLeg ? segments[0].includedServices : segments[segments.length - 1].includedServices;
    includedServices.length > 0 &&
      includedServices.forEach(({ type, ...rest }) => {
        const index = services.findIndex(({ type: serviceType }) => serviceType === firstCharToLowerCase(type));

        setServices((prev) => {
          const newServices = [...prev];
          newServices[index] = { ...rest, ...newServices[index], type: firstCharToLowerCase(type), included: true };
          return newServices;
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root firstLeg={firstLeg}>
      {services.map(({ included, type, maxWeight, quantity, description, allowedPaxTypes }) => {
        return (
          <ServiceWrap key={type}>
            <IconWrap included={included}>
              <FontAwesomeIcon icon={servicesIconsMap[type]} />
            </IconWrap>

            <ServiceDescription>
              <FormattedMessage id={`${type}.label`} description={type} defaultMessage={type} />
            </ServiceDescription>

            {allowedPaxTypes && allowedPaxTypes.includes(INFANT) && <FontAwesomeIcon icon={'baby'} />}
            <ServiceStatus included={included}>
              {included && (
                <ServiceDescription>
                  {maxWeight && `${quantity} x ${maxWeight.value} ${maxWeight.unitOfMeasure}`}
                  &nbsp;
                  {description && `(${description})`}
                  &nbsp;
                </ServiceDescription>
              )}
              {included ? (
                <FormattedMessage id={`includedService.label`} description={'Included'} defaultMessage={'Included'} />
              ) : (
                <FormattedMessage
                  id={`notIncluded.label`}
                  description={'Not Included'}
                  defaultMessage={'Not Included'}
                />
              )}
            </ServiceStatus>
          </ServiceWrap>
        );
      })}
    </Root>
  );
}

const Root = styled.div`
  padding: 20px 20px 8px 20px;
  padding-left: ${({ firstLegs }) => (firstLegs ? '40px' : '20px')};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ServiceWrap = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const IconWrap = styled.div`
  position: relative;
  width: 16px;
  color: ${({ theme, included }) => (included ? theme.colors.text.default : theme.colors.text.grey)};
  font-size: 13px;
`;

const ServiceDescription = styled.p`
  font-size: 13px;
`;

const ServiceStatus = styled.p`
  display: flex;
  color: ${({ theme, included }) => (included ? theme.colors.severity.success[0] : theme.colors.text.grey)};
  margin-left: auto;
  font-style: ${({ included }) => !included && 'italic'};
  font-size: 13px;
`;
